/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VariableValue } from './variableValue';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientVariables { 
    values: Array<VariableValue>;
}
export const PatientVariables_values_Validators: ValidatorFn[] =
    [  Validators.required, ];


